/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled from "styled-components";
import Stack from "../ui/Stack";
import Flex from "../ui/Flex";
import Icon from "../ui/Icon";
import Text from "../ui/Text";
import Badge from "../ui/Badge";
import { useAssetsSrc } from "../../hooks/useAssetsSrc";
import { ServicePriceAndDuration } from "../booking/service/ServiceItemParts";

const Card = styled(Flex)`
  padding: 0.75rem;
  border-radius: 1rem;
  border: 1px solid rgba(${({ theme }) => theme.colors.border.rgba});
`;

const Info = styled(Stack)`
  width: 100%;

  ${({ theme }) => theme.containerMedia.sm} {
    gap: 1rem;
  }
`;

const Header = styled(Flex)`
  width: 100%;

  ${({ theme }) => theme.containerMedia.sm} {
    gap: 0.5rem;
  }
`;

const Media = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 4.625rem;
  height: 4.625rem;
  border-radius: 0.25rem;
  flex-shrink: 0;
  overflow: hidden;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const MembershipServiceCard = ({ service }) => {
  const serviceImage = useAssetsSrc(service?.picture_preview);
  if (!service) return null;

  return (
    <Card $gap="1rem">
      <Media>
        {serviceImage ? <Image src={serviceImage} alt={service.name} /> : <Icon.ServicePlaceholderIcon size={60} />}
      </Media>
      <Info $gap="0">
        <Header $gap="1rem" $align="center" $wrap="wrap" $justify="space-between">
          <Text color="dark" weight="bold" lineClamp={2}>{service.name}</Text>
          {service.memberships?.length > 0 && <Badge color="neutral" title="Membership required" />}
        </Header>
        <ServicePriceAndDuration service={service} />
      </Info>
    </Card>
  );
};

export default MembershipServiceCard;
